var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.750031,
    y: 0.25,
    width: 21.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2501",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.750031,
    y: 0.25,
    width: 21.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2501)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.500031 5.33333H22.5V0H0.500031V5.33333Z",
    fill: "#FF202D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88098 4.26667L9.40479 3.73333L9.9286 4.26667V5.33333H8.88098V4.26667ZM10.9762 4.26667L11.5 3.73333L12.0238 4.26667V5.33333H10.9762V4.26667ZM13.5953 3.73333L13.0715 4.26667V5.33333H14.1191V4.26667L13.5953 3.73333Z",
    fill: "#1895DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4524 3.73333L9.92859 4.26667V5.33333H10.9762V4.26667L10.4524 3.73333ZM12.5476 3.73333L12.0238 4.26667V5.33333H13.0714V4.26667L12.5476 3.73333Z",
    fill: "#191F94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.500031 16H22.5V10.6667H0.500031V16Z",
    fill: "#2027AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9286 5.33333H9.40479L8.88098 6.4H9.9286V7.46667H8.88098V8.53333H9.9286V9.6H8.88098V10.6667H9.9286V11.7333H10.9762V10.6667H12.0238V11.7333H13.0715V10.6667H14.1191V9.6H13.0715V8.53333H14.1191V7.46667H13.0715V6.4H14.1191L13.5953 5.33333H13.0715V6.4H12.0238V5.33333H10.9762V6.4H9.9286V5.33333ZM10.9762 7.46667V6.4H12.0238V7.46667H10.9762ZM10.9762 8.53333V7.46667H9.9286V8.53333H10.9762ZM12.0238 8.53333H10.9762V9.6H9.9286V10.6667H10.9762V9.6H12.0238V10.6667H13.0715V9.6H12.0238V8.53333ZM12.0238 8.53333H13.0715V7.46667H12.0238V8.53333Z",
    fill: "url(#paint0_linear_1_2501)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2501",
    x1: 8.88098,
    y1: 5.33333,
    x2: 8.88098,
    y2: 11.7333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF212E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD0D1B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/hr.0e03ec37a5481e9ba44a89ac3534b5f3.svg";
export { ForwardRef as ReactComponent };